import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { SVGFC } from '@repo/toolkit/types'

const StarFilledIcon: SVGFC = ({ color, color2, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill={color2 ?? tailwindColors.yellow.light}
      />
      <g clipPath="url(#clip0_14743_15509)">
        <path
          d="M19.9583 10.138C19.8536 9.81398 19.5662 9.58387 19.2262 9.55323L14.6082 9.13391L12.7821 4.85975C12.6474 4.54651 12.3408 4.34375 12.0001 4.34375C11.6594 4.34375 11.3527 4.54651 11.2181 4.86049L9.39198 9.13391L4.77321 9.55323C4.43385 9.58461 4.14722 9.81398 4.04187 10.138C3.93652 10.4619 4.03381 10.8173 4.29053 11.0413L7.78122 14.1027L6.7519 18.6368C6.67658 18.9702 6.80598 19.3148 7.0826 19.5148C7.23128 19.6222 7.40524 19.6769 7.58066 19.6769C7.73191 19.6769 7.88193 19.6361 8.01658 19.5556L12.0001 17.1748L15.9821 19.5556C16.2735 19.7309 16.6408 19.7149 16.9168 19.5148C17.1936 19.3142 17.3229 18.9695 17.2475 18.6368L16.2182 14.1027L19.7089 11.0419C19.9656 10.8173 20.0636 10.4626 19.9583 10.138Z"
          fill={color ?? '#FFC107'}
        />
      </g>
      <defs>
        <clipPath id="clip0_14743_15509">
          <rect width="16" height="16" fill="white" transform="translate(4 4)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default StarFilledIcon
